// extracted by mini-css-extract-plugin
module.exports = {"mobileTrailList":"MobileResultsList_mobileTrailList__fc_uB"};